<div *ngIf="exporting">
	<div class="flex align-items-center justify-content-center w-full pb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>
<div *ngIf="!exporting" class="grid">
	<div class="col-12">
		<p-table #buLists dataKey="id" [value]="boardUsersList" [lazy]="true" (onLazyLoad)="loadLists($event)"
			[paginator]="true" [totalRecords]="totalRecords" [loading]="buListsRespLoading" [rows]="pageSize"
			[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
			sortField="CreatedAt" [sortOrder]="-1" responsiveLayout="stack">
			<ng-template pTemplate="header">
				<tr>
					<th>
						<div pSortableColumn="Name" class="flex align-items-center justify-content-center">
							{{ 'NAME' | translate }}
							<p-sortIcon field="Name"></p-sortIcon>
						</div>
					</th>
					<th>
						<div pSortableColumn="CreatedAt" class="flex align-items-center justify-content-center">
							{{ 'CREATED_AT' | translate }}
							<p-sortIcon field="CreatedAt"></p-sortIcon>
						</div>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-list>
				<tr>
					<td>
						<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>{{list.Name}}
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'CREATED_AT' | translate }}</span>{{list.CreatedAt |
						localizedDate: 'medium'}}
					</td>
					<td>
						<span class="p-column-title font-semibold">
						</span>
						<div class="flex flex-row justify-content-center align-items-center gap-1">
							<p-button [disabled]="taskRunning || offline" label="{{'IMPORT_LIST' | translate }}"
								tooltipPosition="bottom" icon="pi cm-cloud-arrow-down" size="large" (click)="importList(list)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
							<p-button pTooltip="{{ 'EDIT_NAME' | translate }} {{ ('LIST' | translate).toLowerCase() }}"
								tooltipPosition="bottom" icon="pi cm-pencil" size="large" (click)="editList(list)"
								[rounded]="false" [text]="true" severity="secondary">
							</p-button>
							<p-button pTooltip="{{ 'DELETE_LIST' | translate }}" tooltipPosition="bottom" icon="pi cm-trash"
								size="large" (click)="deleteList(list)" [rounded]="false" [text]="true" severity="danger">
							</p-button>
						</div>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
